module.exports = __webpack_public_path__ + "static/img/zichan_001.b9166c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zichan_001.png
// module id = pn1m
// module chunks = 1